<template>
  <div>
    <el-row :gutter="5">
      <el-col :span="7" :xs="24">
        <!-- <el-date-picker
            v-model="time"
            :clearable="false"
            :picker-options="pickerOptions"
            end-placeholder="结束日期"
            range-separator="至"
            start-placeholder="开始日期"
            type="daterange"/> -->
        <lp-date-picker
          ref="lpDatePicker" 
          @finish="handleLpDatePickerChange"
        />
      </el-col>
      <el-col :span="4" :xs="24">
        <el-select
          v-model="params.groupId"
          filterable
          ref="select"
          @focus="closeReadOnly"
          @hook:mounted="closeReadOnly"
          @visible-change="closeReadOnly"
          placeholder="小区"
          clearable
        >
          <el-option
            v-for="(item, index) in GroupList"
            :key="index"
            :label="item.groupName"
            :value="item.id"
          >
          </el-option>
        </el-select>
      </el-col>
      <el-col :span="2" :xs="12" class="xs-mp-10">
        <el-button type="primary" @click="search">搜索</el-button>
      </el-col>
      <el-col :span="2" :xs="12" class="xs-mp-10">
        <el-button plain type="success" @click="reset">重置</el-button>
      </el-col>
    </el-row>
    <div style="display: flex; justify-content: flex-end; padding: 5px">
      <el-button
        type="primary"
        icon="el-icon-upload2"
        @click="handleExportTableBtnClick"
        >导出</el-button
      >
    </div>
    <el-table id="exportTab" :data="records" class="m-mp-10" stripe>
      <el-table-column label="日期" prop="day" />
      <el-table-column align="center" label="我的分润">
        <el-table-column label="余额分润" prop="agentBalanceDividend" />
        <el-table-column label="豆币分润" prop="agentTokenDividend" />
      </el-table-column>

      <el-table-column align="center" label="总支出">
        <el-table-column label="余额支出" prop="balanceDisburse" />
        <el-table-column label="豆币支出" prop="tokenDisburse" />
      </el-table-column>

      <el-table-column align="center" label="总营收">
        <el-table-column label="余额营收" prop="balanceExpenditure" />
        <el-table-column label="豆币营收" prop="tokenExpenditure" />
      </el-table-column>

      <el-table-column align="center" label="包月">
        <el-table-column label="充电包月" prop="monthlyBalanceIncome" />
        <el-table-column label="代开充电" prop="monthlyTokenIncome" />
        <el-table-column label="停车包月" prop="carportMonthlyBalanceIncome" />
        <el-table-column label="代开停车" prop="carportMonthlyTokenIncome" />
      </el-table-column>

      <el-table-column align="center" label="临时">
        <el-table-column label="充电消费" prop="weChatExpenditure" />
        <el-table-column label="停车消费" prop="weChatParkingExpenditure" />
        <el-table-column label="刷卡消费" prop="cardExpenditure" />
        <el-table-column label="刷卡停车" prop="cardParkingExpenditure" />
      </el-table-column>

      <el-table-column label="后台代充" prop="cardTokenRecharge" />
      <el-table-column label="电度" prop="power" />
    </el-table>
  </div>
</template>

<script>
import getGroupList from "@/api/device/device-group-manage/getGroupList";
import agentGetDailyReport from "@/api/fund/order-manage/agentGetDailyReport";
import createdMixin from "@/mixin/createMixin";
import numberFilters from "@/mixin/numberFilters";
import searchMixin from "@/mixin/searchMixin";
import timeMixin from "@/mixin/timeMixin";
import { exportTableToExcel } from "@/utils/exportTable";
import { EndTime, StartTime, day } from "@/utils/time";
import { mapGetters } from "vuex";

export default {
  name: "RevenueChartOne",
  mixins: [timeMixin, createdMixin, numberFilters, searchMixin],
  data() {
    return {
      rules: {
        time: [{ required: true, message: "请选择时间" }],
      },
      time: [],
      records: [],
      GroupList: [],
      params: {
        startTime: StartTime() - 1,
        endTime: EndTime() - 24 * 60 * 60,
        sortName: undefined,
        sortType: undefined,
        groupId: undefined,
      },
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now();
        },
      },
    };
  },
  computed: {
    ...mapGetters(["info"]),
    _maxDate() {
      return this.time[0]
        ? new Date(this.time[0])
         + 30 * 24 * 60 * 60 * 1000
        : new Date(Date.now() + 3650 * 30 * 24 * 60 * 60 * 1000);
    },
  },
  mounted() {
    this.initDate();

    getGroupList().then((res) => {
      this.GroupList = res.data;
    });
  },
  methods: {
    closeReadOnly(value) {
      this.$nextTick(() => {
        if (!value) {
          const { select } = this.$refs;
          const input = select.$el.querySelector(".el-input__inner");
          input.removeAttribute("readonly");
          // this.$refs.select.blur();  根据tip自行判断是否添加
        }
      });
    },
    handleExportTableBtnClick() {
      exportTableToExcel("exportTab", [], "营收报表(日报).xlsx", true);
    },
    initDate() {
      if (this.$refs["lpDatePicker"]) {
        let dates = [this.params.startTime * 1000, this.params.endTime * 1000];
        this.$refs["lpDatePicker"].setDate(...dates);
        this.time = dates;
      }
    },
    search() {
      if (this.time.length === 2) {
        this.params.startTime = this.time[0] / 1000;
        this.params.endTime = this.time[1] / 1000;

        console.log(this.params.startTime, StartTime() - 1);
        console.log(this.params.endTime, EndTime() - 24 * 60 * 60);
        if (this.params.startTime > StartTime() - 1) {
          return this.$message.error("开始日期不能大于今天");
        }
        if (this.params.endTime > EndTime() - 24 * 60 * 60) {
          return this.$message.error("结束日期不能大于今天");
        }

        this.fetchData();
      } else {
        this.$message.error("请先选择日期");
      }
    },
    reset() {
      this.params.startTime = StartTime() - 1;
      this.params.endTime = EndTime() - 24 * 60 * 60;
      this.params.groupId = undefined;
      this.initDate();
      this.fetchData();
    },
    fetchData() {
      const loading = this.$loading({
        lock: true,
        text: "加载中",
        spinner: "el-icon-loading",
        background: "rgba(0, 0, 0, 0.7)",
      });

      agentGetDailyReport({
        startDate: day(this.params.startTime),
        endDate: day(this.params.endTime),
        groupId: this.params.groupId,
      })
        .then((res) => {
          this.records = res.data;
          if (res.code != 1) {
            this.$message.error(res.msg);
          }
        })
        .finally(() => {
          loading.close();
        });
    },
  },
};
</script>
